// 资产图表组件国际化配置 - 简体中文
export default {
  // 图表标题
  balanceChange: "总资产余额变化(近六个月)",
  transactionBoard: "交易看板",
  unit: "单位:USDT",

  // 标签页
  tabs: {
    balanceTrend: "余额趋势",
    transactionOverview: "交易看板",
  },

  // 提示信息
  tooltips: {
    addToBoard: "可在画布中选择地址后右键加入交易看板",
    calculating: "总资产余额变化数据计算中，请稍后查看",
  },

  // 交易统计
  transaction: {
    earliestInflow: "最早转入(USDT)",
    earliestOutflow: "最早转出(USDT)",
    transactionCount: "交易次数(次)",
    transactionAmount: "交易数量",
    counterParty: "交易对手",
  },

  // 通用
  detail: "详情 >",
  noData: "暂无数据",
  loadingText: "拼命加载中",

  // 错误提示
  errors: {
    loadChartFailed: "加载图表数据失败,请稍后重试",
    loadTransactionFailed: "加载交易数据失败,请稍后重试",
  },
};
